<template>
    <v-dialog v-model="projectSendDialog" width="400">
        <v-card component="ProjectSendDialog">
            <btn class="close" size="icon" color="transparent" :icon="'close'" @click="close" />

            <v-form v-model="valid" ref="form">
                <div class="header">
                    <p>Please enter the email address where the shortlist will be sent for approval.</p>
                    <v-combobox
                        v-model="emails"
                        label="Approval emails"
                        :rules="emailsRules"
                        @change="splitEmails"
                        deletable-chips
                        autofocus
                        clearable
                        multiple
                        chips
                    >
                    </v-combobox>
                </div>

                <div class="action">
                    <div class="buttons">
                        <btn color="transparent" :text="'Cancel'" @click="close" />
                        <div class="holder" :class="{ confirm: confirm }">
                            <btn
                                class="send"
                                icon="send"
                                text="Send for approval"
                                tpos="left"
                                color="'base"
                                @click.prevent="validateApproveRequest"
                            />
                            <btn
                                class="confirm"
                                icon="check"
                                text="Confirm emails"
                                tpos="left"
                                color="'accent"
                                :state="loading"
                                @click.prevent="submit"
                            />
                        </div>
                    </div>
                    <div class="message" :class="{ done: done }">
                        <i class="icon">done_all</i>
                        <h3>Project approval request was sent.</h3>
                    </div>
                </div>
            </v-form>
        </v-card>
    </v-dialog>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex';

const emailRegex =
    /^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;

export default {
    name: 'ProjectSendDialog',

    props: {
        project: {
            type: Object,
            required: true,
        },
    },

    data() {
        return {
            loading: '',
            emails: [],
            confirm: false,
            done: false,
            emailsRules: [
                (v) => v.length > 0 || 'At least one e-mail is required',
                (v) =>
                    v.map((i) => emailRegex.test(i)).every((i) => i === true) ||
                    'Input contains one or more invalid emails',
            ],
            valid: true,
        };
    },

    created() {
        if (this.projectWasSent) {
            this.emails = this.getProject.schvalenie_email.split(',');
        }
    },

    methods: {
        ...mapActions(['sendApproveRequest']),
        ...mapMutations(['setProjectSendDialog']),

        reset() {
            this.email = null;
            this.loading = '';
            this.confirm = false;
            this.done = false;
        },

        close(evt) {
            this.setProjectSendDialog(false);
            this.reset();
        },

        splitEmails() {
            this.emails = this.emails.reduce((res, item) => {
                const unique = new Set([...res, ...item.split(/[\s,;]+/).map((i) => i.trim())]);
                return (res = [...unique]);
            }, []);
        },

        validateApproveRequest() {
            this.$refs.form.validate();
            if (!this.valid) {
                return;
            }
            this.confirm = true;
        },

        async submit() {
            this.loading = 'load';
            this.$refs.form.validate();
            if (!this.valid) {
                this.loading = '';
                return;
            }

            await this.sendApproveRequest({
                id: this.project.id,
                emails: this.emails,
                project_type: this.getProjectTypeVoiceFace,
            });

            this.loading = '';
            this.confirm = false;
            this.done = true;

            setTimeout(() => {
                this.setProjectSendDialog(false);
                this.reset();
            }, 2000);
        },
    },

    computed: {
        ...mapGetters(['getProjectSendDialog', 'projectWasSent', 'getProject', 'getProjectTypeVoiceFace']),

        projectSendDialog: {
            get: function () {
                return this.getProjectSendDialog;
            },
            set: function (val) {
                this.setProjectSendDialog(val);
            },
        },
    },
};
</script>

<style lang="less" scoped>
@import '~@variables';

[component='ProjectSendDialog'] {
    padding: 20px;

    .close {
        position: absolute;
        top: 0;
        right: 0;
        margin: 0;
    }

    form {
        display: flex;
        flex-direction: column;
    }

    .header {
        margin-bottom: 25px;

        p {
            margin: 0 30px 15px 0;
        }
    }

    .action {
        position: relative;
        overflow: hidden;
        width: 100%;
        .flex-row;
        justify-content: flex-end;

        .buttons {
            .flex-row;
        }

        .holder {
            position: relative;

            &.confirm {
                .send {
                    transform: translateY(100%);
                }

                .confirm {
                    transition-delay: 0.3s;
                    transform: translateY(0);
                }
            }

            button {
                transition: 0.3s;

                &.confirm {
                    position: absolute;
                    top: 0;
                    right: 0;
                    z-index: 4;
                    transform: translateY(100%);
                    transition-delay: 0.3s;
                }
            }
        }
    }

    .message {
        position: absolute;
        background: white;
        width: 100%;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        z-index: 5;
        color: @base;
        transition: 0.3s;
        transition-delay: 0.3s;
        transform: translateY(100%);

        &.done {
            transition-delay: 0s;
            transform: translateY(0);
        }

        h3 {
            color: @base;
            margin: 0 0 0 5px;
        }
    }
}
</style>
